/**
 * Load More
 * add button like
 * <div class="loadmore" data-type="qualitymarks" data-maxpages="{!! (int) $posts->max_num_pages !!}" data-curpage="1" data-list=".classname">{{ __('Mehr laden', 'ral')}}</div>
 */

document.addEventListener("DOMContentLoaded", function (event) {
  let el = document.querySelector(".loadmore");

  if (el) {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      var categoryParam = new URLSearchParams(window.location.search).get("category");

      var searchParam = new URLSearchParams(window.location.search).get("s");

      // var jobSearch = new URLSearchParams(window.location.search).get("job_search");

      var currentLang = document.documentElement.lang;

      var xhttp = new XMLHttpRequest();
      xhttp.open("POST", window.ajax_params.ajax_url, true);
      xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded; charset=UTF-8");
      xhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          // Response
          let response = this.responseText;
          let curPage = parseInt(e.target.getAttribute("data-curpage"));
          let maxPages = parseInt(e.target.getAttribute("data-maxpages"));
          const listWrapper = e.target.getAttribute("data-list");

          el.setAttribute("data-curpage", ++curPage);

          if (curPage >= maxPages) {
            el.remove();
          }

          //add content
          let content = document.querySelector(listWrapper);
          content.insertAdjacentHTML("beforeend", response);
        }
      };

      let sendVar =
        "action=loadmore_" +
        el.getAttribute("data-type") +
        "&pageType=" +
        el.getAttribute("data-type") +
        "&curPage=" +
        parseInt(el.getAttribute("data-curpage")) +
        "&lang=" +
        currentLang.split("-")[0] +
        "&nonce=" +
        window.ajax_params.nonce; // Include the nonce

      // if we have categories
      if (el.getAttribute("data-type") === "news" || el.getAttribute("data-type") === "events") {
        sendVar += "&categories=" + categoryParam;
      }

      // EVENTS
      if (el.getAttribute("data-type") === "events") {
        sendVar += "&isArchive=" + el.getAttribute("data-archive");
        sendVar += "&showTeaser=" + el.getAttribute("data-showteaser");
        sendVar += "&viewMode=" + el.getAttribute("data-viewmode");
      }

      // DEFAULT SEARCH
      else if (el.getAttribute("data-type") === "search") {
        sendVar += "&s=" + searchParam;
      }

      // JOB SEARCH
      // else if (el.getAttribute("data-type") === "jobs" && jobSearch != null) {
      //   sendVar += "&job_search=" + jobSearch;
      // }

      xhttp.send(sendVar);
    });
  }
});
